var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from './index';
var HelpPage = function () {
    var _a = __read(useState(false), 2), webWidgetSetup = _a[0], setWebWidgetSetup = _a[1];
    var t = useContext(AppContext).t;
    useEffect(function () {
        window.zESettings = {
            webWidget: {
                key: '01802835-59bb-4595-9dce-e1cb8e4fca1a',
                position: { horizontal: 'right', vertical: 'top' },
                chat: {
                    suppress: false,
                    connectOnPageLoad: false,
                    notifications: {
                        mobile: {
                            disable: true
                        }
                    },
                },
                answerBot: {
                    suppress: true,
                    title: {
                        '*': 'Chat with us!'
                    },
                    contactOnlyAfterQuery: false,
                    avatar: {
                        url: 'https://cdn.scribblemaps.com/assets/images/mappy-hello.png',
                        name: {
                            '*': 'Mappy'
                        }
                    }
                }
            }
        };
        var loadZendeskWidget = function () {
            var script = document.createElement('script');
            script.src = 'https://static.zdassets.com/ekr/snippet.js?key=01802835-59bb-4595-9dce-e1cb8e4fca1a';
            script.async = true;
            script.id = 'ze-snippet';
            script.onload = function () {
                var zE = window.zE;
                if (zE) {
                    zE('webWidget', 'hide');
                }
            };
            document.body.appendChild(script);
        };
        loadZendeskWidget();
    }, []);
    return (React.createElement("div", { className: "helpPage" },
        React.createElement("div", { className: 'toolGuide' },
            React.createElement("h2", null, t("help_page.tools_header")),
            React.createElement("ul", null, [
                { icon: 'search', title: t('help_page.tools.search_title'), description: t('help_page.tools.search_description') },
                { icon: 'drag', title: t('help_page.tools.move_map_title'), description: t('help_page.tools.move_map_description') },
                { icon: 'edit', title: t('help_page.tools.edit_measure_title'), description: t('help_page.tools.edit_measure_description') },
                { icon: 'eraser', title: t('help_page.tools.eraser_title'), description: t('help_page.tools.eraser_description') },
                { icon: 'slash', title: t('help_page.tools.slash_title'), description: t('help_page.tools.slash_description') },
                { icon: 'scribble', title: t('help_page.tools.scribble_title'), description: t('help_page.tools.scribble_description') },
                { icon: 'line', title: t('help_page.tools.line_title'), description: t('help_page.tools.line_description') },
                { icon: 'polygon', title: t('help_page.tools.polygon_title'), description: t('help_page.tools.polygon_description') },
                { icon: 'marker', title: t('help_page.tools.marker_title'), description: t('help_page.tools.marker_description') },
                { icon: 'text', title: t('help_page.tools.label_title'), description: t('help_page.tools.label_description') },
                { icon: 'photo', title: t('help_page.tools.camera_title'), description: t('help_page.tools.camera_description') },
                { icon: 'settings', title: t('help_page.tools.settings_title'), description: t('help_page.tools.settings_description') },
            ].map(function (_a, index) {
                var icon = _a.icon, title = _a.title, description = _a.description;
                return (React.createElement("li", { key: index },
                    React.createElement("div", { className: "icon ".concat(icon) }),
                    React.createElement("div", { className: 'info' },
                        React.createElement("div", { className: 'title' }, title),
                        React.createElement("div", { className: 'description' }, description))));
            }))),
        React.createElement("div", { className: "support" },
            React.createElement("h2", null, t("help_page.support_header")),
            React.createElement("div", { className: 'item', onClick: function () {
                    var _a;
                    if (window['zE']) {
                        var zE_1 = window['zE'];
                        zE_1('webWidget', 'show');
                        if ((_a = window.appSettings) === null || _a === void 0 ? void 0 : _a.email) {
                            zE_1('webWidget', 'identify', {
                                email: window.appSettings.email,
                                name: window.appSettings.email,
                            });
                            zE_1('webWidget', 'prefill', {
                                email: {
                                    value: window.appSettings.email,
                                    readOnly: true,
                                },
                            });
                        }
                        zE_1('webWidget', 'updateSettings', {
                            webWidget: {
                                helpCenter: {
                                    suppress: true
                                }
                            }
                        });
                        if (zE_1 && !webWidgetSetup) {
                            zE_1('webWidget:on', 'close', function () {
                                zE_1('webWidget', 'hide');
                                zE_1('webWidget', 'updateSettings', {
                                    webWidget: {
                                        helpCenter: {
                                            suppress: false,
                                        },
                                    },
                                });
                            });
                            zE_1('webWidget:on', 'open', function () {
                                zE_1('webWidget', 'updateSettings', {
                                    position: { horizontal: 'right', vertical: 'top' },
                                });
                                zE_1('webWidget', 'show');
                            });
                            setWebWidgetSetup(true);
                        }
                        zE_1('webWidget', 'open');
                    }
                } },
                React.createElement("div", { className: 'icon ticket' }),
                React.createElement("div", { className: 'info' },
                    React.createElement("div", { className: 'title' }, t("help_page.create_a_ticket")),
                    React.createElement("div", { className: 'description' }, t("help_page.submit_a_ticket")))),
            React.createElement("div", { className: 'item', onClick: function () {
                    window.open('https://help.scribblemaps.com/hc/en-us/community/topics', '_blank');
                } },
                React.createElement("div", { className: 'icon forum' }),
                React.createElement("div", { className: 'info' },
                    React.createElement("div", { className: 'title' }, t("help_page.forum")),
                    React.createElement("div", { className: 'description' }, t("help_page.forum_description")))))));
};
export default HelpPage;
